import { service } from '@/utils/request'
import api from '@/api'
// import { setToken, removeToken, setStorage, removeAllStorge } from '@/utils/auth'

const texture = {
  state: {
    token: '',
    helpModalStatus: false // 全局认证弹窗显示状态
  },

  mutations: {
    getQiniuToken (state, data) {
      state.token = data
    },
    changeHelpModalStatus (state, data) {
      state.helpModalStatus = data
    }
  },

  actions: {
    // 获取素材信息
    getTextureInfo ({ commit, state }, params) {
      return service.get(`/pccloud/cloud_package_info`, { params })
    },
    // 提交或者保存 素材
    submitTextureEdit ({ commit, state }, params) {
      return service.post('/pccloud/cloud_package_edit', params)
    },
    // 获取素材列表
    getTextureList ({ commit, state }, params) {
      return service.get(`/pccloud/cloud_package_list`, { params })
    },
    // 删除素材
    delTexture ({ commit, state }, params) {
      return service.post(`/pccloud/cloud_package_del`, params)
    },
    async getQiniuToken ({ commit, state }, data) {
      const { auth_token } = (await api.qiniu.getImageToken(data)).data
      commit('getQiniuToken', auth_token)
      return auth_token
    },
    changeHelpModalStatus ({ commit }, data) {
      commit('changeHelpModalStatus', data)
    }
  }
}

export default texture
